
import React, { useState, InputHTMLAttributes } from "react";
import { FormInput } from "@/components/ui/form-input";
import { Eye, EyeClosed } from "lucide-react";

interface AuthTokenInputProps extends Omit<InputHTMLAttributes<HTMLInputElement>, "type"> {
  value: string;
  masked: boolean;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  revealed: boolean;
  onToggleReveal: () => void;
  showToggleButton: boolean;
}

export const AuthTokenInput: React.FC<AuthTokenInputProps> = ({
  value,
  masked,
  onChange,
  revealed,
  onToggleReveal,
  showToggleButton,
  ...props
}) => {
  // If revealed, type=password becomes text. Else always password.
  const inputType = revealed ? "text" : "password";
  // Render asterisks if masked and not revealed
  const displayValue = masked && !revealed ? "*".repeat(Math.max(8, value.length)) : value;

  return (
    <div className="relative">
      <FormInput
        label="Twilio Auth Token"
        type={inputType}
        value={displayValue}
        onChange={onChange}
        required
        minLength={8}
        placeholder="********"
        autoComplete="off"
        {...props}
      />
      {showToggleButton && (
        <button
          type="button"
          tabIndex={-1}
          aria-label={revealed ? "Hide token" : "Show token"}
          onClick={onToggleReveal}
          className="absolute top-7 right-3 p-1 text-muted-foreground hover:text-primary"
          style={{ background: "none", border: "none" }}
        >
          {revealed ? <Eye size={20} /> : <EyeClosed size={20} />}
        </button>
      )}
    </div>
  );
};
